import { gql } from '@apollo/client';

export const getFinalPriceForProducts = gql`
  query getFinalPriceForProducts(
    $getFinalPriceForProductsRequest: GetFinalPriceForProductsRequest!
  ) {
    getFinalPriceForProducts(
      getFinalPriceForProductsRequest: $getFinalPriceForProductsRequest
    ) {
      productFinalPrices {
        productId
        exceptionId
        finalPrice {
          amount
          markup {
            value
            markupAmountType
          }
          tax {
            value
            taxAmountType
          }
          adminFeeTax {
            rate
            taxAmountType
          }
          adminFee {
            adminFeeAmountType
            value
          }
        }
        sellingPrice {
          grossTax
          grossMarkup
          listPrice
          netPrice
          grossAdminFee
          grossAdminFeeTax
        }
      }
    }
  }
`;
